//#region types
import { Icon, MenuButton, RoundButton } from "components/common";
import { AutomationRuleEnums, StyleEnums } from "models/enums";
import { ListMoreActionButtonProps } from "models/propTypes/automationRulePropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import useDeleteConfirmation from "../forms/useDeleteConfirmation";
import { useAutomationRuleService } from "serviceHooks";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { AutomationRuleTypeHelper, LocalizationHelperInstance } from "utils/helpers";

const ListMoreActionButton: React.FC<ListMoreActionButtonProps> = (props) => {
  const { row, onActionSuccess } = props;

  const { activateReceiptDraftRule, deactivateReceiptDraftRule, deleteReceitpDraftRule } = useAutomationRuleService();
  const { deleteConfirmationDialog } = useDeleteConfirmation();

  const activateHandler = async () => {
    if (!row.ruleId) return;

    return await activateReceiptDraftRule(row.ruleId);
  };

  const deactivateHandler = async () => {
    if (!row.ruleId) return;

    return await deactivateReceiptDraftRule(row.ruleId);
  };

  const onDelete = async () => {
    if (!row.ruleId) return;

    const type = AutomationRuleTypeHelper.getRuleTypeEnumByApiTypeAndSubType(row.ruleType, row.ruleSubtype);
    if (row.ruleId && type) {
      switch (type) {
        case AutomationRuleEnums.AutomationRuleType.ReceiptDraft:
          await deleteReceitpDraftRule(row.ruleId);
          break;
        default:
          throw new Error(`Unsupported automation rule type: ${type}`);
      }
    }
  };

  const getMoreActionItems = () => {
    const moreactionsMenu: MoreActionMenuItemType[] = [];

    if (row.isActive) {
      moreactionsMenu.push({
        description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Deactivate),
        icon: IconDefinitionConstants.WStop,
        highlightType: StyleEnums.DisplayType.Danger,
        onClickHandler: deactivateHandler,
      });
    } else {
      moreactionsMenu.push({
        description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Activate),
        icon: IconDefinitionConstants.WStop,
        onClickHandler: activateHandler,
      });
    }

    moreactionsMenu.push({
      description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Delete),
      icon: IconDefinitionConstants.WTrashAlt,
      highlightType: StyleEnums.DisplayType.Danger,
      actionDialog: deleteConfirmationDialog(onDelete),
    });

    return moreactionsMenu;
  };

  return (
    <MenuButton
      menuItems={getMoreActionItems()}
      menuPlacement="bottom-end"
      disablePopperPortal={false}
      popperOffSet={[15, 5]}
      button={
        <RoundButton size="xs" displayType={StyleEnums.DisplayType.None} className={cssExports.listMoreActions}>
          <Icon icon={IconDefinitionConstants.WEllipsisH} />
        </RoundButton>
      }
      classes={{
        menuOpen: cssExports.listMoreActionsMenuOpen,
      }}
      onActionSuccess={onActionSuccess}
    />
  );
};

export default ListMoreActionButton;
